export const getBadge = product => {
  const badgeTag = product.tags.find(tag => tag.startsWith("badge::"))
  return badgeTag && badgeTag.replace("badge::", "")
}

export const isMens = product => product.tags.includes("Mens")
export const isWomens = product => product.tags.includes("Womens")

export const isPreOrder = product => product.tags.includes("pre-order")
